import { render, staticRenderFns } from "./fuzzy-tag.vue?vue&type=template&id=6b805b1a&scoped=true&"
import script from "./fuzzy-tag.vue?vue&type=script&lang=js&"
export * from "./fuzzy-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b805b1a",
  null
  
)

export default component.exports